import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, icons, services } from '@/utils'

import button from '@/components/button'

export default function(h) {
  let icon = icons.remove_circle
  let color = Colors.error
  if (this.isActive) {
    icon = icons.check_circle_outline
    color = Colors.success
  }

  return h(
    button,
    {
      props: {
        icon,
        color,
        mode: buttonModes.flat,
        loading: this.loading,
        disabled: this.loading,
        tooltip: this.getTranslate(`${services.providers}.tooltips.buttons.isActive`)
      },
      key: this.value.id,
      on: {
        click: () => {
          this.update()
        }
      }
    }
  )
}
